<div class="simple-form-aligner">
  <mat-card class="simple-form-card">
    <mat-card-content>
      <a [href]="this.homepageLinks.home">
        <div class="register-logo" role="img" alt="Logo"></div>
      </a>

      <h1>Register</h1>

      <app-log-in-google-button></app-log-in-google-button>

      <h2>Or register manually</h2>

      <form [formGroup]="form" (ngSubmit)="submit(form.value)">
        <fieldset [disabled]="waiting">
          <div class="form-group">
            <mat-form-field class="simple-form-field-100" floatLabel="always">
              <mat-label>Name</mat-label>
              <input
                matInput
                type="text"
                name="name"
                id="name"
                formControlName="name"
                autocomplete="name"
                required
              />
              <mat-error>Required</mat-error>
            </mat-form-field>

            <mat-form-field
              class="simple-form-field-100"
              [floatLabel]="'always'"
            >
              <mat-label>Email</mat-label>
              <input
                matInput
                type="text"
                name="email"
                formControlName="email"
                autocomplete="email"
                required
              />
              <mat-error>Not a valid email</mat-error>
            </mat-form-field>

            <mat-form-field
              class="simple-form-field-100"
              [floatLabel]="'always'"
            >
              <mat-label>Password</mat-label>
              <input
                matInput
                type="password"
                name="password"
                formControlName="password"
                autocomplete="new-password"
                required
              />
              <mat-progress-bar
                [color]="updatePasswordProgressColor(passwordGuessesLog10)"
                mode="determinate"
                value="{{ passwordProgressBarValue.toString() }}"
              >
              </mat-progress-bar>
              <mat-error>{{ passwordErrorMessage }}</mat-error>
            </mat-form-field>

            <div class="button-right-container">
              <div></div>
              <div>
                <div class="spinner-container" *ngIf="waiting">
                  <mat-spinner diameter="24"></mat-spinner>
                </div>
                <button
                  mat-raised-button
                  color="primary"
                  [disabled]="waiting || disableSubmit"
                  type="submit"
                  value="submit"
                >
                  Register
                </button>
              </div>
            </div>
            <span *ngIf="formErrorMessage" class="text-error-color">
              {{ formErrorMessage }}
            </span>

            <p>
              Already have an account?
              <a
                routerLink="/login"
                [queryParams]="loginRegisterSwitchQueryParams"
                class="text-link"
              >
                Log in here.
              </a>
            </p>

            <p>
              <br />
              By registering, you agree to our
              <a [href]="this.homepageLinks.privacy" class="text-link"
                >Privacy Policy</a
              >
              and our
              <a [href]="this.homepageLinks.terms" class="text-link"
                >Terms and Conditions.</a
              >
              This site is protected by reCAPTCHA.
            </p>
          </div>
        </fieldset>
      </form>
    </mat-card-content>
  </mat-card>
</div>
